import { useState } from "react";
import { useTranslation } from "react-i18next";

import { DatePicker } from "@/components/shared/tables/tableDatePicker";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { TypographyP, TypographySmall } from "@/components/ui/typography";
import { cn } from "@/lib/utils";

type Props = {
  disabled: boolean;
  importDate: Date;
  onSubmit: (importDate: Date) => Promise<void>;
};

export const KanzleilandIntegrationStepTwo = ({
  importDate,
  onSubmit,
  disabled,
}: Props) => {
  const { t } = useTranslation();
  const [date, setDate] = useState(new Date(importDate ?? new Date()));

  const handleSubmit = async () => {
    await onSubmit(date);
  };

  return (
    <div className={cn("flex flex-col gap-2", disabled && "opacity-50")}>
      <div className="flex flex-row gap-2 items-center">
        <div className="w-10 h-10 bg-muted rounded-full flex items-center justify-center">
          <TypographyP className="text-muted-foreground">2</TypographyP>
        </div>
        <div className="flex flex-col gap-1">
          <TypographySmall>
            {t("integrations.kanzleiland.step_2")}
          </TypographySmall>
          <TypographySmall className="text-muted-foreground">
            {t("integrations.kanzleiland.step_2_description")}
          </TypographySmall>
        </div>
      </div>
      <div className="flex flex-row gap-2">
        <div className="flex justify-center h-auto w-10">
          <Separator orientation="vertical" />
        </div>
        <div className="flex-1 mt-2">
          <div className="grid w-full items-center gap-4 mb-2">
            {!disabled && (
              <div className="flex flex-col space-y-2">
                <Label htmlFor="taxAdvisorNumber">
                  {t("integrations.kanzleiland.import_date_label")}
                </Label>
                <DatePicker
                  inputDate={date}
                  onSelect={setDate}
                  variant="outline"
                  disabled={disabled}
                />
              </div>
            )}
            {!disabled && (
              <div>
                <Button onClick={handleSubmit}>
                  {t("integrations.kanzleiland.save")}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
